import TranslationAiCharts from "./translation-ai-charts";


const SettingsCharts = {
    TranslationAi: TranslationAiCharts,
};

export default SettingsCharts;
